import React, { useEffect } from 'react';
import './App.css';
import './loaders.css';
import Header from './Header';
import Landing from './Landing';
import Footer from './Footer';
import Commercial from './Commercial';
import Residential from './Residential';
import { createBrowserRouter, RouterProvider, Outlet, useLocation } from 'react-router-dom';
import Project from './Project';
import Studio from './Studio';
import ScrollToTop from './ScrollToTop';
import WhatWeDo from './WhatWeDo';
import LetsTalk from './LetsTalk';
import AddProject from './AddProject';
import AddBlog from './AddBlog';
import BlogPage from './BlogPage';
import BlogDetails from './BlogDetails';
import PrivacyPolicy from './PrivacyPolicy';
import './sampleBlogs'; // Import sample blogs for testing
import { initGA, logPageView } from './services/analyticsService';

// Layout wrapper to keep Header/Footer around all routes
function Layout() {
  const location = useLocation();

  useEffect(() => {
    // Initialize Google Analytics on first load
    initGA();
  }, []);

  useEffect(() => {
    // Track page views on route changes
    logPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return (
    <div className="App" style={{ backgroundColor: '#fff' }}>
      <Header />
      <ScrollToTop />
      <main className="btw-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Landing /> },
      { path: 'commercial', element: <Commercial /> },
      { path: 'studio', element: <Studio /> },
      { path: 'residential', element: <Residential /> },
      { path: 'project/:slug', element: <Project /> },
      { path: 'whatwedo', element: <WhatWeDo /> },
      { path: 'letstalk', element: <LetsTalk /> },
      { path: 'add-project', element: <AddProject /> },
      { path: 'add-blog', element: <AddBlog /> },
      { path: 'blog', element: <BlogPage /> },
      { path: 'blog/:id', element: <BlogDetails /> },
      { path: 'privacy-policy', element: <PrivacyPolicy /> },
    ],
  },
]);

function App() {
  return (
    <RouterProvider
      router={router}
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    />
  );
}

export default App;
